import { render, staticRenderFns } from "./header-bottom.vue?vue&type=template&id=6ca532b2&scoped=true&"
import script from "./header-bottom.vue?vue&type=script&lang=js&"
export * from "./header-bottom.vue?vue&type=script&lang=js&"
import style0 from "./header-bottom.vue?vue&type=style&index=0&id=6ca532b2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca532b2",
  null
  
)

export default component.exports